// extracted by mini-css-extract-plugin
module.exports = {"ComponentHolder":"LoadingComponet_ComponentHolder__2oJct"};